import rollOverApi from "./rollOverApi";
import {
  rollOverLoading,
  rollOverLoaded,
  rollOverLoadingError,
  rollOverSaving,
  rollOverSaved,
  rollOverSavingError,
  loadingRollsForChildService,
  loadedRollsForChildService,
  loadedRollsForChildServiceError,
} from "./rollOverStateActions";
import { Child } from "../../../types/models";
import {
  IRollOverScheduleUpdateHttpRequest,
  RollHttpResponse,
  RollOverScheduleHttpResponse,
  RollOverScheduleOptHttpRequest,
  RollOverScheduleUpdatesHttpRequest,
  RollOverStatusHttpRequest,
} from "../../parentApi";

export function getRollOverSchedules(dispatch: any, customerAccountId: number) {
  dispatch(rollOverLoading());
  rollOverApi.getRollOverSchedules(customerAccountId).then(
    (rollOverSchedules: RollOverScheduleHttpResponse[]) => {
      dispatch(rollOverLoaded(rollOverSchedules));
    },
    function (error: any) {
      dispatch(rollOverLoadingError());
    }
  );
}

export function rollOverSchedulesOpt(
  dispatch: any,
  customerAccountId: number,
  childId: number,
  rollIds: number[],
  rollOverStatus: RollOverStatusHttpRequest,
  finishCallback: () => void
) {
  dispatch(rollOverSaving());

  var request = new RollOverScheduleOptHttpRequest();
  request.init({
    childId: childId,
    rollIds: rollIds,
    rollOverStatus: rollOverStatus,
    scheduleCancellationReasonId: null,
  });

  rollOverApi
    .rollOverScheduleOpt(customerAccountId, request)
    .then(
      function (rollOverSchedules: RollOverScheduleHttpResponse[]) {
        dispatch(rollOverSaved(rollOverSchedules));
      },
      function () {
        dispatch(rollOverSavingError());
      }
    )
    .finally(() => finishCallback());
}

export function rollOverSchedulesUpdate(
  dispatch: any,
  customerAccountId: number,
  schedules: IRollOverScheduleUpdateHttpRequest[],
  finishCallback: () => void
) {
  dispatch(rollOverSaving());

  var request = new RollOverScheduleUpdatesHttpRequest();
  request.init({ schedules: schedules });

  rollOverApi
    .rollOverSchedulesUpdate(customerAccountId, request)
    .then(
      function (rollOverSchedules: RollOverScheduleHttpResponse[]) {
        dispatch(rollOverSaved(rollOverSchedules));
      },
      function () {
        dispatch(rollOverSavingError());
      }
    )
    .finally(() => finishCallback());
}

export function rollOverSchedulesCancel(
  dispatch: any,
  customerAccountId: number,
  childId: number,
  rollIds: number[],
  scheduleCancellationReasonId: number,
  finishCallback: () => void
) {
  dispatch(rollOverSaving());

  var request = new RollOverScheduleOptHttpRequest();
  request.init({
    childId: childId,
    rollIds: rollIds,
    rollOverStatus: RollOverStatusHttpRequest.OptIn,
    scheduleCancellationReasonId,
  });

  rollOverApi
    .rollOverScheduleOpt(customerAccountId, request)
    .then(
      function (rollOverSchedules: RollOverScheduleHttpResponse[]) {
        dispatch(rollOverSaved(rollOverSchedules));
      },
      function () {
        dispatch(rollOverSavingError());
      }
    )
    .finally(() => finishCallback());
}

export function getRollsForChild(dispatch: any, child: Child) {
  dispatch(loadingRollsForChildService());
  rollOverApi.getRollsForChild(child.childId!).then(
    (response: RollHttpResponse[] | null) =>
      response
        ? dispatch(loadedRollsForChildService({ child: child, rollsForChild: response }))
        : dispatch(loadedRollsForChildServiceError()),
    (error: any) => dispatch(loadedRollsForChildServiceError())
  );
}
